const exercise = {
  exercise: "Übung",
  create: "Übung erstellen",
  edit: "Übung bearbeiten",
  createExerciseInstruction:
    'Geben Sie die Frage ein, markieren Sie im Text den/die Teil(e), die der Antwort entsprechen, und klicken Sie auf die Schaltfläche "Antwort", um zu bestätigen. Bitte geben Sie die Anzahl der Fragen entsprechend der gewählten Bewertungsrichtlinie ein.',
  doExercises: "Üben",
  exercises: "Übungen",
};

export default exercise;
